import { useQueryClient } from '@tanstack/react-query';

import {
	ALL_CELLS,
	SITES_DB,
} from '@constants/queryKeys';

export const useInvalidateSites = () => {
	const queryClient = useQueryClient();

	const invalidateSites = () => {
		return [
			queryClient.invalidateQueries([SITES_DB]),
			queryClient.invalidateQueries([ALL_CELLS]),
		];
	};

	return {
		invalidateSites,
	};
};
